import React from 'react';
import { Typography } from '@mui/material';
import HelpModal from '../../../Common/HelpModal';
import { getTextColor } from '../../../BomManagement/utils/styleUtils';

/**
 * 설비정보수정 도움말 내용 컴포넌트
 * 
 * @param {Object} props - 컴포넌트 속성
 * @param {boolean} props.isHelpModalOpen - 도움말 모달 표시 여부
 * @param {Function} props.setIsHelpModalOpen - 도움말 모달 표시 여부 설정 함수
 * @param {string} props.domain - 도메인
 * @param {boolean} props.isDarkMode - 다크모드 여부
 * @returns {JSX.Element}
 */
const HelpContent = ({ isHelpModalOpen, setIsHelpModalOpen, domain, isDarkMode }) => {
  return (
    <HelpModal
      open={isHelpModalOpen}
      onClose={() => setIsHelpModalOpen(false)}
      title="센서 및 설비 수정 도움말"
    >
      <Typography variant="body2" color={getTextColor(domain, isDarkMode)}>
        • 센서 및 설비 수정에서는 설비 장비 이름과 센서 정보를 변경할 수 있으며, 관리하는 곳입니다.
      </Typography>
      <Typography variant="body2" color={getTextColor(domain, isDarkMode)}>
        • 지부 선택 드롭다운에서 지부를 선택하면 해당 지부에 속한 센서와 설비들을 볼 수 있습니다.
      </Typography>
      <Typography variant="body2" color={getTextColor(domain, isDarkMode)}>
        • 센서 정보를 수정하기 위해 설비장비와 센서정보를 관리바랍니다.
      </Typography>
      <Typography variant="body2" color="primary" sx={{ mt: 2 }}>
        1. 수정 모드 진입 <br />
        - 수정' 버튼 클릭: 상세 화면에서 '수정' 버튼을 누르면 화면이 수정 모드로 전환됩니다. <br />
            잠금 해제: 수정 모드에서는 모든 입력 필드가 활성화되어 내용을 직접 수정할 수 있습니다. <br />
            버튼 변경: '수정' 버튼은 '저장' 버튼과 '취소' 버튼으로 변경됩니다. <br /> <br />

        2. 정보 수정 <br />
        - 입력 필드 수정: 원하는 항목의 내용을 클릭하여 수정합니다. <br />
            항목 선택: 드롭다운 메뉴가 있는 항목(예: 설비 선택)은 클릭하여 목록에서 새 항목을 선택할 수 있습니다.<br />
            주의사항: 필수 입력 항목은 비워둘 수 없으며, 유효하지 않은 형식의 데이터(예: 숫자가 들어가야 할 곳에 문자를 입력)는 저장되지 않습니다. <br />

      </Typography>
    </HelpModal>
  );
};

export default HelpContent; 